import { Link } from 'expo-router';
import { memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { IconStore, Text, tokens } from '@fhs/ui';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { CHECKOUT_STORE_SECTION } from '@fhs-legacy/frontend/src/utils/test-ids';

function StoreSection() {
  const { store } = useStoreContext();

  return (
    <View testID={CHECKOUT_STORE_SECTION} style={styles.storeSection}>
      <View style={styles.storeIcon}>
        <IconStore size={24} />
      </View>
      <View style={{ flex: 1 }}>
        <Text.Ui size="xs">Pick up at:</Text.Ui>
        <Text.Heading numberOfLines={2} type="three">
          {store.name}
        </Text.Heading>
        <Text.Ui numberOfLines={2} size="sm">
          {[
            store?.physicalAddress?.address1,
            store?.physicalAddress?.city,
            store?.physicalAddress?.stateProvince,
          ].join(', ')}
        </Text.Ui>
      </View>
      <View>
        <Link href="/store-locator?back=/cart/payment" asChild>
          <Text.Ui style={styles.changeStoreLink} size="sm">
            Change
          </Text.Ui>
        </Link>
      </View>
    </View>
  );
}

export default memo(StoreSection);

const styles = StyleSheet.create({
  storeSection: {
    width: '100%',
    gap: 8,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 0,
    marginBottom: 20,
  },

  changeStoreLink: {
    textDecorationLine: 'underline',
  },

  storeIcon: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
  },
});
